import i18n from '@/utils/i18n';
const state = {
  serveIndexData: [],
  commentData: [],
  queryDate: {
    startDate: '',
    endDate: ''
  },
  lossData: [],
  orderData: {
    channelOrderInfoList: []
  },
  reportData: {},
  flowData: [],
  flowSubmitData: []
}
const mutations = {
  SET_FLOW_DATA(state, arr) {
    state.flowData = arr
  },
  SET_SERVE_INDEX_DATA(state, arr) {
    state.serveIndexData = arr
  },
  SET_QUERY_DATE(state, arr) {
    state.queryDate = arr
  },
  SET_COMMENT_DATA(state, arr) {
    state.commentData = arr
  },
  SET_LOSS_DATA(state, arr) {
    state.lossData = arr
  },
  SET_ORDER_DATA(state, obj) {
    state.orderData = obj
  },
  SET_REPORT_DATA(state, obj) {
    state.reportData = obj
  },
  SET_FLOW_SUBMIT_DATA(state, arr) {
    state.flowSubmitData = arr
  }
}
export default {
  state,
  mutations
}
